module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_30.a2e15087.png";